export default __webpack_public_path__ + "static/media/btn_debloquer.436d1488.svg";